import { render, staticRenderFns } from "./ProjectSummaryView.vue?vue&type=template&id=088a1e2c&"
import script from "./ProjectSummaryView.vue?vue&type=script&lang=js&"
export * from "./ProjectSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports